import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F1120LPCHeadersService {

  constructor(private http: HttpClient) { }

  savefDomesticHeaders(baseUrl: string, returnClobSettingsObj: any, fDomesticSaveDtls: any, globalService: any, filterParams: any): Observable<any> {
    if (!baseUrl) {
      throw new Error('Base URL is not available');
    }
    
    const url = `${baseUrl}/saveJsonObject?action_code=cg99gw`;
    
    console.log('💾 Save returnClobSettingsObj:', returnClobSettingsObj);
    console.log('💾 Save fDomesticSaveDtls:', fDomesticSaveDtls);
    console.log('🔍 GlobalService for save:', globalService);
    console.log('🔍 FilterParams for save:', filterParams);
    
    // ✅ Basic parameters from global and filter params
    const basicParams = _.merge({}, globalService.globalParams || {}, filterParams || {});
    console.log('🔍 BasicParams merged:', basicParams);
    
    // ✅ CRITICAL: Add checkLockedbj like AngularJS  
    const checkLockedbj = [{
      leid: filterParams?.leid || globalService?.leid || filterParams?.entity_leid || 'HC1351',
      cdr_number: filterParams?.cdr_number || globalService?.cdr_number || filterParams?.entity_leid || 'HC1351', 
      consol_group_key: "1",
      reporting_period: "1", 
      combination_key: (filterParams?.combination_key || basicParams?.combination_key || '2177663').toString(), // ✅ Add fallback
      scenario_key: (basicParams.scenario || '74').toString() // ✅ Add fallback
    }];
    
    console.log('🔍 checkLockedbj created:', checkLockedbj);
    
    // ✅ CRITICAL: Use URLSearchParams instead of FormData (like original $http.post)
    const params = new URLSearchParams();
    
    // ✅ CRITICAL: Add parameters in EXACT order like AngularJS (NO action_code in form data!)
    params.set('clob_settings', JSON.stringify(returnClobSettingsObj));
    params.set('clob_data', JSON.stringify(fDomesticSaveDtls));
    params.set('tax_year', (basicParams.tax_year || '').toString());
    params.set('screen_key', (basicParams.screen_key || '').toString());
    params.set('scenario', (basicParams.scenario || '').toString());
    params.set('jcd_key', (basicParams.jcd_key || '').toString());
    params.set('jcd_ta_key', (basicParams.jcd_ta_key || '').toString());
    params.set('activity_key', (basicParams.activity_key || '').toString());
    params.set('screen_type', basicParams.screen_type || '');
    params.set('is_locked', basicParams.is_locked || 'N');
    params.set('issue_id', basicParams.issue_id || '');
    params.set('issue_short_desc', basicParams.issue_short_desc || '');
    params.set('issue_id_for_tx_save', basicParams.issue_id_for_tx_save || '');
    params.set('checkLockedbj', JSON.stringify(checkLockedbj));
    params.set('scenarioCode', 'RAF'); // ✅ CRITICAL: Should be "RAF" not scenario number
    params.set('is_issue_key_enabled', basicParams.is_issue_key_enabled || 'N');
    params.set('filing_key', (basicParams.filing_key || '').toString());
    params.set('parent_me_string', basicParams.parent_me_string || '');
    params.set('entity_type', basicParams.entity_type || '');
    params.set('process_name', 'F1120LPC_SAVE_HEADER');
    
    console.log('🚀 Final URLSearchParams being sent:');
    console.log('📋 All params:', params.toString());
    console.log('🔍 Key params check:', {
      tax_year: params.get('tax_year'),
      scenario: params.get('scenario'), 
      jcd_key: params.get('jcd_key'),
      scenarioCode: params.get('scenarioCode'),
      is_issue_key_enabled: params.get('is_issue_key_enabled'),
      clob_settings: params.get('clob_settings'),
      clob_data: params.get('clob_data')?.substring(0, 100) + '...'
    });
    
    // ✅ CRITICAL: Send as URL-encoded form data (like AngularJS $http.post)
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    
    return this.http.post(url, params.toString(), { headers });
  }

  // Legacy alias from Gridsave mapping (Form1120LPCFactory.save1120LPCHeaderDetails)
  save1120LPCHeaderDetails(
    baseUrl: string,
    returnClobSettingsObj: any,
    fDomesticSaveDtls: any,
    globalService: any,
    filterParams: any,
    rowData?: any
  ): Observable<any> {
    return this.savefDomesticHeaders(baseUrl, returnClobSettingsObj, fDomesticSaveDtls, globalService, filterParams);
  }

  // Method to fetch domestic headers data
  fetchDomesticHeadersData(baseUrl: string, globalService: any, filterParams: any): Observable<any> {
    if (!baseUrl) {
      throw new Error('Base URL is not available');
    }
    
    const url = `${baseUrl}/loadJsonObject`;
    
    // ✅ CRITICAL: Use all parameters from working AngularJS call + GET method
    let httpParams = new HttpParams()
      .set('action_code', 'g68nns')
      .set('tax_year', filterParams?.tax_year || '')
      .set('scenario', filterParams?.scenario || '')
      .set('jcd_key', globalService?.globalParams?.jcd_key || '')
      .set('combination_key', filterParams?.combination_key || '')
      .set('entity_type', filterParams?.entity_type || '')
      // ✅ Add missing parameters from working AngularJS
      .set('activity_key', globalService?.globalParams?.activity_key || '')
      .set('filing_key', filterParams?.filing_key || '')
      .set('is_locked', globalService?.globalParams?.is_locked || 'N')
      .set('issue_id', globalService?.globalParams?.issue_id || '')
      .set('issue_id_for_tx_save', globalService?.globalParams?.issue_id_for_tx_save || '')
      .set('issue_short_desc', globalService?.globalParams?.issue_short_desc || '')
      .set('jcd_ta_key', globalService?.globalParams?.jcd_ta_key || '')
      .set('parent_me_string', filterParams?.parent_me_string || '')
      .set('screen_key', globalService?.globalParams?.screen_key || '')
      .set('screen_type', globalService?.globalParams?.screen_type || '');
    
    console.log('🚀 API GET Request to:', url);
    console.log('🔗 With params:', httpParams.toString());
    
    // ✅ CRITICAL: Use GET instead of POST (like original AngularJS)
    return this.http.get(url, { params: httpParams });
  }
}
